
    <div>
<div class="video-main">
    <div class="video" >
        <video src="../../../assets/videos/chillhop.mp4" loop="true" autoplay="true" controls
         poster="../../../assets/img/landpage/antenna-cw-cj_nFa14-unsplash.jpg"></video>    
    </div>

    <div class="modules">
      <ul>
        <h4>
         <span>
           <svg id="bundle-line" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="23" height="23" viewBox="0 0 36 36">
             <defs>
               <clipPath id="clip-inline">
                 <path id="Mask" d="M13.6,31.9l-13-6.19a1,1,0,0,1-.6-.92V8.24a1,1,0,0,1,.57-.9L15.57.1a1,1,0,0,1,.87,0l13,6.21a1,1,0,0,1,.6.9V23.76a1,1,0,0,1-.571.9l-15,7.24a1,1,0,0,1-.87,0Z" transform="translate(0.99 0.04)"/>
               </clipPath>
             </defs>
             <g id="color" transform="translate(2 2)">
               <path id="Mask-2" data-name="Mask" d="M13.6,31.9l-13-6.19a1,1,0,0,1-.6-.92V8.24a1,1,0,0,1,.57-.9L15.57.1a1,1,0,0,1,.87,0l13,6.21a1,1,0,0,1,.6.9V23.76a1,1,0,0,1-.571.9l-15,7.24a1,1,0,0,1-.87,0Z" transform="translate(0.99 0.04)"/>
               <g id="color-2" data-name="color" clip-path="url(#clip-inline)">
                 <g id="color-3" data-name="color" transform="translate(-2 -2)">
                   <rect id="Rectangle" width="36" height="36" fill="#fff"/>
                 </g>
               </g>
             </g>
           </svg>
         </span>
         Module 1: Logic gates</h4>
       <ol>
           <li>Number system and its complements</li>
           <li>Number system and its complements</li>
           <li>Number system and its complements</li>
           <li>Number system and its complements</li>
           <li>Number system and its complements</li>
       </ol>
   </ul>

        <ul>
          <h4>
           <span>
             <svg id="bundle-line" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="23" height="23" viewBox="0 0 36 36">
               <defs>
                 <clipPath id="clip-inline">
                   <path id="Mask" d="M13.6,31.9l-13-6.19a1,1,0,0,1-.6-.92V8.24a1,1,0,0,1,.57-.9L15.57.1a1,1,0,0,1,.87,0l13,6.21a1,1,0,0,1,.6.9V23.76a1,1,0,0,1-.571.9l-15,7.24a1,1,0,0,1-.87,0Z" transform="translate(0.99 0.04)"/>
                 </clipPath>
               </defs>
               <g id="color" transform="translate(2 2)">
                 <path id="Mask-2" data-name="Mask" d="M13.6,31.9l-13-6.19a1,1,0,0,1-.6-.92V8.24a1,1,0,0,1,.57-.9L15.57.1a1,1,0,0,1,.87,0l13,6.21a1,1,0,0,1,.6.9V23.76a1,1,0,0,1-.571.9l-15,7.24a1,1,0,0,1-.87,0Z" transform="translate(0.99 0.04)"/>
                 <g id="color-2" data-name="color" clip-path="url(#clip-inline)">
                   <g id="color-3" data-name="color" transform="translate(-2 -2)">
                     <rect id="Rectangle" width="36" height="36" fill="#fff"/>
                   </g>
                 </g>
               </g>
             </svg>
           </span>
           Module 1: Logic gates</h4>
         <ol>
             <li>Number system and its complements</li>
             <li>Number system and its complements</li>
             <li>Number system and its complements</li>
             <li>Number system and its complements</li>
             <li>Number system and its complements</li>
         </ol>
     </ul>

        <ul>
             <h4>
              <span>
                <svg id="bundle-line" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="23" height="23"  viewBox="0 0 36 36">
                  <defs>
                    <clipPath id="clip-inline">
                      <path id="Mask" d="M13.6,31.9l-13-6.19a1,1,0,0,1-.6-.92V8.24a1,1,0,0,1,.57-.9L15.57.1a1,1,0,0,1,.87,0l13,6.21a1,1,0,0,1,.6.9V23.76a1,1,0,0,1-.571.9l-15,7.24a1,1,0,0,1-.87,0Z" transform="translate(0.99 0.04)"/>
                    </clipPath>
                  </defs>
                  <g id="color" transform="translate(2 2)">
                    <path id="Mask-2" data-name="Mask" d="M13.6,31.9l-13-6.19a1,1,0,0,1-.6-.92V8.24a1,1,0,0,1,.57-.9L15.57.1a1,1,0,0,1,.87,0l13,6.21a1,1,0,0,1,.6.9V23.76a1,1,0,0,1-.571.9l-15,7.24a1,1,0,0,1-.87,0Z" transform="translate(0.99 0.04)"/>
                    <g id="color-2" data-name="color" clip-path="url(#clip-inline)">
                      <g id="color-3" data-name="color" transform="translate(-2 -2)">
                        <rect id="Rectangle" width="36" height="36" fill="#fff"/>
                      </g>
                    </g>
                  </g>
                </svg>
              </span>
              Module 1: Logic gates</h4>
            <ol>
                <li>Number system and its complements</li>
                <li>Number system and its complements</li>
                <li>Number system and its complements</li>
                <li>Number system and its complements</li>
                <li>Number system and its complements</li>
            </ol>
        </ul>
    </div>


    <div class="headline">
        <ul>
            <li>
    
             <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="50" height="50" viewBox="0 0 311 311">
                 <defs>
                   <linearGradient id="linear-gradient" x1="-0.126" y1="0.549" x2="0.753" y2="0.594" gradientUnits="objectBoundingBox">
                     <stop offset="0" stop-color="#5c3aed"/>
                     <stop offset="0.623" stop-color="#6851c9" stop-opacity="0.667"/>
                     <stop offset="0.699" stop-color="#756ba1" stop-opacity="0.302"/>
                     <stop offset="0.707" stop-color="#797296" stop-opacity="0.2"/>
                     <stop offset="0.803" stop-color="#7a7592" stop-opacity="0.161"/>
                     <stop offset="1" stop-color="gray" stop-opacity="0"/>
                   </linearGradient>
                   <pattern id="pattern" preserveAspectRatio="xMidYMid slice" width="100%" height="100%" viewBox="0 0 500 750">
                     <image width="500" height="750" href="../../../assets/svg/user/img1.jpeg"></image></pattern>
                 </defs>
                 <g id="Group_23" data-name="Group 23" transform="translate(-17894.345 810.655)">
                   <circle id="Ellipse_1" data-name="Ellipse 1" cx="155.5" cy="155.5" r="155.5" transform="translate(17894.344 -810.655)" fill="url(#linear-gradient)"/>
                   <g id="photo-1545946551-0b395ce5b5f4" transform="translate(17919.344 -785.655)" stroke="#707070" stroke-width="1" fill="url(#pattern)">
                     <circle cx="131" cy="131" r="131" stroke="none"/>
                     <circle cx="131" cy="131" r="130.5" fill="none"/>
                   </g>
                 </g>
               </svg>
    
            </li>
            <li> 
              <h4>Prof: John Doe</h4>
              <p>Logica combinaciona <strong>History</strong> </p> 
              <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Eveniet, adipisci veniam at beatae
                 quisquam porro impedit, dignissimos vero sapiente 
                 aspernatur asperiores? Dolores rerum magni delectus 
                 nam odit earum quaerat iure.</p>
          </li>
            <li class="slide-book">
              <div >
                <p><strong> <span>Livros</span></strong> <strong><span>Slides</span></strong>
                 </p>
              </div> 
            </li>
        </ul>
    </div>


</div>


</div>